<template>
  <div>
    <reports-title
      ref="reportsTitle"
      :title="pageTitle"
    />
    <reports-toolbar
      ref="reportsToolbar"
      :active-report-view-mode="reportViewMode"
      :drop-menu="modelsOfCalculationsMenu"
      :range-value="toolbarRange"
      :report-title="pageTitle"
      :toolbar-disabled="isStatic || isAllDisabled"
      @onSelectDropdown="onChangeCalculationMode"
      @onSelectReportViewMode="onSelectReportViewMode"
      @onClickExport="onExport"
    />
    <skeleton-wrapper
      v-if="isShowSkeleton"
      id="skeletonWrapper"
      :style="{ height: contentHeight }"
    >
      <template #body>
        <line-chart
          v-if="reportViewMode === 'graphic'"
          id="report_export_id"
          :config="stubConfig"
          :is-static="true"
          :show-stub-message="false"
        />
        <skeletonTable v-if="reportViewMode === 'table'" />
      </template>
    </skeleton-wrapper>
    <div v-else>
      <line-chart
        v-if="reportViewMode === 'graphic'"
        id="report_export_id"
        :config="chartConfig"
        :is-static="isStatic"
        @onAllLegendsDisabled="flag => isAllDisabled = flag"
      />
      <report-table
        v-if="reportViewMode === 'table'"
        ref="table"
        :config="tableConfig"
        :rows-data="tableData"
        :grouping="[]"
        :skin="'horizontal-borders'"
        :local-storage-table-id="currentFilter.type"
        :style="{ height: contentHeight }"
      />
    </div>
  </div>
</template>

<script>
import reportsTitle from '../include/title.vue';
import reportsToolbar from '../include/toolbar.vue';
import lineChart from '../include/charts/lineChart.vue';

import constants from '$$helpers/constants';
// import moduleGanttDateWorker from '../../gantt/modules/ganttDateWorker';
import Progress from '../progress/controllerReportsProgress';
import charts from '../progress/configCharts';
import reportsConstants from '../include/constants';
import skeletonWrapper from '../../common/VueComponents/skeletons/skeletonWrapper.vue';
import statusHelper from '../../../helpers/status';
import reportHelpers from '../include/helpers';
import reportTable from '../include/table/table.vue';
import progressTableConfigs from '../progress/configTable';
import skeletonTable from '../include/table/skeleton.vue';
import Export from '../include/export/export';
import tableHelpers from '../include/table/helpers';

export default {
  name: 'ProgressByMonthReportPage',
  components: {
    reportsTitle, reportsToolbar, lineChart, skeletonWrapper, reportTable, skeletonTable,
  },
  data() {
    return {
      locale: __,
      reportViewMode: '',
      projectId: null,
      baselineId: null,
      baselineData: {},
      baselines: [],
      chartConfig: {},
      stubConfig: {},
      tableData: [],
      calculationMode: constants.OVERVIEW_TYPES.ACTUAL_TO_PLANNED,
      toolbarRange: '',
      isStatic: true,
      isShowSkeleton: true,
      isAllDisabled: false,
      contentHeight: '0px',
    };
  },
  computed: {
    pageTitle() {
      return reportsConstants.TITLE.progress.monthProgress;
    },
    modelsOfCalculationsMenu() {
      return reportHelpers.getModelsOfCalculationsMenu(this.isStatic, this.calculationMode, this.baselines, this.baselineId);
    },
    currentFilter() {
      return this.$store.getters['filter/currentFilter'];
    },
    baselineTasks() {
      if (this.baselineData?.tasks) {
        const tasksAndMilestones = this.baselineData.tasks.filter(task => task.type === constants.TASK_TYPES.task || task.type === constants.TASK_TYPES.milestone);

        return tasksAndMilestones;
      }

      return [];
    },
    tableConfig() {
      const config = progressTableConfigs.progressByMonth(this.calculationMode);

      return tableHelpers.getColumnVisibilityByCalculationMode(config, this.calculationMode);
    },
    baselineEnabledByCalculationMode() {
      const baselineEnabledByCalculationMode = [
        constants.OVERVIEW_TYPES.ACTUAL_TO_BASELINE, constants.OVERVIEW_TYPES.PLANNED_TO_BASELINE
      ].includes(this.calculationMode)

      return baselineEnabledByCalculationMode;
    }
  },
  watch: {
    'currentFilter.properties': {
      handler(newProps, oldProps) {
        if (!newProps && !oldProps) return;

        this.calculateReportByFilter(newProps, oldProps);
      },
      deep: true,
      immediate: true,
    },
    reportViewMode(newVal) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          mode: newVal,
        },
      });
    },
    calculationMode(newVal) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          calculationModel: newVal,
        },
      });
    },
  },
  created() {
    this.chartConfig = charts.monthProgressChart().stub;
    this.stubConfig = charts.monthProgressChart().stub;
  },
  beforeUnmount() {
    this.chartConfig = {};
    this.stubConfig = {};
    window.removeEventListener('resize', this.calcContentHeight);
  },
  async mounted() {
    const reportNameAnalytics = this.pageTitle.replace(/^exmp_chart_/, '').replace(/_title$/, '');

    userExtAnalytics.log('report_open', {
      report_type: reportNameAnalytics,
      calculation_mode: this.calculationMode,
    });

    this.init();
    this.calcContentHeight();
    window.addEventListener('resize', this.calcContentHeight);
  },
  methods: {
    calcContentHeight() {
      const viewportHeight = document.documentElement.clientHeight || window.innerHeight || 0;

      const titleRef = this.$refs.reportsTitle;
      const toolbarRef = this.$refs.reportsToolbar;

      const titleEl = titleRef && (titleRef.$el || titleRef);
      const toolbarEl = toolbarRef && (toolbarRef.$el || toolbarRef);

      const titleHeight = titleEl?.getBoundingClientRect().height || 0;
      const toolbarHeight = toolbarEl?.getBoundingClientRect().height || 0;

      const height = Math.max(viewportHeight - titleHeight - toolbarHeight, 0);

      this.contentHeight = `${height}px`;
    },
    init() {
      this.reportViewMode = this.$route?.query?.mode || 'graphic';
      this.calculationMode = this.$route?.query?.calculationModel || constants.OVERVIEW_TYPES.ACTUAL_TO_PLANNED;
      this.calculateReportByFilter(this.currentFilter.properties);
    },

    async calculateReportByFilter(newProps, oldProps = null) {
      reportHelpers.watchChangedFilterProps(newProps, oldProps, {
        gantt_id: this.setProjectId,
        rangeDate: this.setRange,
      });

      if (this.projectId) {
        await this.getBaselines();
        this.updateFilterUIAndCalculationMode();
        this.calcProgressReport();
      } else {
        this.baselineId = null;
        this.baselines = [];
        this.baselineData = {};
        this.tableData = [];
        this.chartConfig = { ...charts.monthProgressChart().stub };
        this.isStatic = true;

        this.updateFilterAdvancedSettings();
      }
    },

    async setProjectId(ids) {
      if (ids?.length) {
        this.projectId = ids[0];
      } else {
        this.projectId = null;
      }
    },

    setRange() {
      this.toolbarRange = reportHelpers.setToolbarRangeValue(this.currentFilter);
    },

    async getBaselines() {
      this.baselineId = null;
      this.baselines = [];
      this.baselineData = {};

      await this.$store.dispatch('baselines/fetchBaselines', this.projectId);

      const baselines = this.$store.getters['baselines/getProjectBaselines'](this.projectId)
        .map(item => ({ ...item, created_at: new Date(item.created_at) }))
        .sort((a, b) => a.created_at - b.created_at);

      if (baselines?.length) {
        this.baselines = baselines;
        this.baselineId = baselines[baselines.length - 1].id;
        await this.getBaselineData(this.baselineId);
      }
    },
    async getBaselineData(baselineId) {
      const baseline = this.baselines.find(b => b.id === +baselineId);

      if (!baseline) {
        this.baselineData = {};

        return
      }

      const data = await this.$store.dispatch('baselines/getBaselineData', { projectId: baseline.gantt_id, eventId: baseline.event_id });

      if (data) {
        this.baselineData = data;
        this.baselineId = baselineId;
      }
    },
    async calcProgressReport() {
      const result = await Progress.calculateMonthProgressReport({
        projectId: this.projectId,
        calculationMode: this.calculationMode,
        baselineTasks: this.baselineTasks,
      });

      if (result) {
        this.chartConfig = { ...result.chart };
        this.tableData = result.table;
        this.isStatic = false;
      } else {
        this.tableData = [];
        this.baselineId = null;
        this.baselines = [];
        this.baselineData = {};

        setTimeout(() => {
          this.chartConfig = { ...charts.monthProgressChart().stub };
          this.isStatic = true;
        }, 0);
      }

      setTimeout(() => {
        this.isShowSkeleton = false;
      }, 500)

      statusHelper.handlers.hideMainSpinner();
    },
    async onChangeCalculationMode(selected) {
      statusHelper.handlers.showMainSpinner();
      const reportNameAnalytics = this.pageTitle.replace(/^exmp_chart_/, '').replace(/_title$/, '');

      userExtAnalytics.log('report_calculation_mode_change', {
        report_type: reportNameAnalytics,
        from: this.calculationMode,
        to: selected.type,
      });

      this.calculationMode = selected.type;
      let baselineId = selected.baselineId;

      if (selected.type === constants.OVERVIEW_TYPES.PLANNED_TO_BASELINE) {
        baselineId = this.baselines[this.baselines.length - 1].id;
      }

      if (baselineId) {
        await this.getBaselineData(baselineId);
      } else {
        this.baselineId = null;
      }

      this.calcProgressReport();
      this.updateFilterAdvancedSettings({
        baselineEnabled: this.baselineId !== null,
      })
    },
    onSelectReportViewMode(data) {
      this.reportViewMode = data.type;
    },
    onExport() {
      const analyticTypeFormat = this.reportViewMode === 'table' ? 'XLSX' : 'PDF';

      if (this.reportViewMode === 'table') {
        Export.exportTanstackTableDataToExcel({
          title: __(`${this.pageTitle}`),
          tableInstance: this.$refs.table?.tableController?.tableInstance,
          reportType: 'progress',
        });
      }

      if (this.reportViewMode === 'graphic') {
        Export.exportReportGraphicToPdf({
          title: __(`${this.pageTitle}`),
          range: this.toolbarRange,
        });
      }

      userExtAnalytics.log('report_export_done', {
        export_format: analyticTypeFormat,
        report_type: 'report_progress_by_month',
      });
    },

    updateFilterUIAndCalculationMode() {
      if (!this.baselineEnabledByCalculationMode) {
        this.updateFilterAdvancedSettings();
      }

      if (this.baselineEnabledByCalculationMode && !this.baselines.length) {
        this.resetCalculationMode();
        this.updateFilterAdvancedSettings({
          baselineEnabled: false,
          isShowNotificationMessage: !!this.projectId,
        })
      }

      if (this.baselineEnabledByCalculationMode) {
        this.updateFilterAdvancedSettings({
          baselineEnabled: true,
          isShowNotificationMessage: false,
        })
      }
    },

    updateFilterAdvancedSettings(settings = {}) {
      const defaultFilterSettings = {
        type: this.currentFilter.type,
        settings: {
          baselineEnabled: false,
          isShowNotificationMessage: false,
        }
      }

      this.$store.commit('filter/updateAdvancedSettingsByFilterType', {
        ...defaultFilterSettings,
        settings: {
          ...defaultFilterSettings.settings,
          ...settings
        }
      });
    },

    resetCalculationMode() {
      this.calculationMode = constants.OVERVIEW_TYPES.ACTUAL_TO_PLANNED;
    }
  },
};
</script>
